import { render, staticRenderFns } from "./ExpressaoValor.vue?vue&type=template&id=1869d438&scoped=true"
import script from "./ExpressaoValor.vue?vue&type=script&lang=js"
export * from "./ExpressaoValor.vue?vue&type=script&lang=js"
import style0 from "./ExpressaoValor.vue?vue&type=style&index=0&id=1869d438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1869d438",
  null
  
)

export default component.exports